/* ct-d.js · Build 9-23 · Option D behaviours.
   1. Lead line + more (details.ctd-more): open by default on desktop, closed on phones.
   2. Existing PDP blocks marked .ct-lm collapse on phones to their first N children (data-lead), with a toggle.
   3. PDP title: the part before " · " reads as the name, the part after as a sub line. The H1 text stays whole.
*/
(function () {
  var DESK = window.matchMedia('(min-width: 750px)');

  function openDetailsOnDesktop() {
    if (!DESK.matches) return;
    var list = document.querySelectorAll('details.ctd-more[data-desktop-open]');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].hasAttribute('data-user')) list[i].open = true;
    }
  }
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('details.ctd-more')) t.setAttribute('data-user', '1');
  }, true);

  function collapseBlocks() {
    /* the theme's description block gets the same treatment: first two paragraphs, then "Read the full story" */
    var MAP = [
      ['.product__info-container .product__description', 2, 'Read the full story'],
      ['.product__info-container .ct-jarfit', 2, 'More on the fit'],
      ['.product__info-container .ct-cardswrap', 1, 'Every ingredient, one card each'],
      ['.product__info-container .ct-compare', 1, 'Show the comparison']
    ];
    for (var m = 0; m < MAP.length; m++) {
      var el = document.querySelector(MAP[m][0]);
      if (el && !el.classList.contains('ct-lm')) { el.classList.add('ct-lm'); el.setAttribute('data-lead', String(MAP[m][1])); el.setAttribute('data-more', MAP[m][2]); }
    }
    var blocks = document.querySelectorAll('.ct-lm');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (b.hasAttribute('data-lm-done')) continue;
      b.setAttribute('data-lm-done', '1');
      var n = parseInt(b.getAttribute('data-lead') || '1', 10);
      var kids = [];
      for (var k = 0; k < b.children.length; k++) {
        var c = b.children[k];
        if (c.tagName === 'STYLE' || c.tagName === 'SCRIPT') continue;
        kids.push(c);
      }
      if (kids.length <= n) continue;
      for (var j = 0; j < n; j++) kids[j].classList.add('ct-lm__keep');
      var t = document.createElement('a');
      t.className = 'ct-lm__toggle';
      t.setAttribute('role', 'button');
      t.setAttribute('tabindex', '0');
      t.textContent = b.getAttribute('data-more') || 'Read more';
      b.appendChild(t);
      b.classList.add('is-collapsed');
      (function (box, link) {
        function flip(ev) {
          if (ev) ev.preventDefault();
          var closed = box.classList.toggle('is-collapsed');
          link.textContent = closed ? (box.getAttribute('data-more') || 'Read more') : 'Show less';
        }
        link.addEventListener('click', flip);
        link.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') flip(ev); });
      })(b, t);
    }
  }

  function splitTitle() {
    var h = document.querySelector('.product__info-container .product__title h1, .product__info-container h1.product__title, .product__title h1');
    if (!h || h.hasAttribute('data-ct-split')) return;
    var raw = h.textContent.trim();
    var at = raw.indexOf(' · ');
    if (at < 0) return;
    h.setAttribute('data-ct-split', '1');
    var name = raw.slice(0, at);
    var rest = raw.slice(at + 3);
    h.textContent = '';
    var a = document.createElement('span'); a.className = 'ctd-t-name'; a.textContent = name;
    var d = document.createElement('span'); d.className = 'ctd-t-dot'; d.textContent = ' · ';
    var s = document.createElement('span'); s.className = 'ctd-t-sub'; s.textContent = rest;
    h.appendChild(a); h.appendChild(d); h.appendChild(s);
  }

  /* 4. Lead sections (.ctd-lead-sec): one button opens every "more" part; open by default on desktop. */
  function leadSections() {
    var secs = document.querySelectorAll('.ctd-lead-sec');
    for (var i = 0; i < secs.length; i++) {
      var sec = secs[i];
      if (sec.hasAttribute('data-ld-done')) continue;
      sec.setAttribute('data-ld-done', '1');
      var btn = sec.querySelector('.ctd-toggle');
      if (DESK.matches && sec.hasAttribute('data-desktop-open')) { sec.classList.add('is-open'); if (btn) btn.setAttribute('aria-expanded', 'true'); }
      if (btn) {
        btn.addEventListener('click', (function (box, b) {
          return function () { var open = box.classList.toggle('is-open'); b.setAttribute('aria-expanded', open ? 'true' : 'false'); };
        })(sec, btn));
      }
    }
  }

  function boot() { openDetailsOnDesktop(); collapseBlocks(); splitTitle(); leadSections(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();